import { Badge, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@nexus/ui"
import { useTranslation } from "react-i18next"

const TOOLTIP_DELAY_MS = 300

/**
 * Marks a persona whose source data BigQuery no longer returns (AD-2139).
 *
 * Only ever rendered from historical context — an opportunity set generated before the
 * persona went stale, or the detail drawer opened from one. Live lists filter stale
 * personas out server-side, so this badge never appears in the Library or onboarding.
 */
export function PersonaStaleBadge() {
  const { t } = useTranslation()

  return (
    <TooltipProvider delayDuration={TOOLTIP_DELAY_MS}>
      <Tooltip>
        <TooltipTrigger asChild>
          {/*
            `slate` is the design system's metadata chip, which is what this is — a fact
            about the persona's provenance. The `badge-status-*` variants are reserved for
            workflow states, and borrowing one would tie this to a restyle it has no part in.
          */}
          <Badge variant="slate" iconStart="info" className="cursor-help">
            {t("personas.stale.badge", "No longer available")}
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs">
          {t(
            "personas.stale.tooltip",
            "This persona is no longer in your source data, so it can't be used for new opportunity sets. Past results are kept for reference.",
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
